import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const LoadingChoiceModal = () => {
  const history = useHistory();

  let [recentDataMessage, setRecentDataMessage] = useState('');
  let [isOnline, setIsOnline] = useState(true);

  let {
    serverUpdatedAt,
    localUpdatedAt,
    loadChillerLogsFromLocalStorage,
    fetchChillerLogs,
    loadingDialogOpen,
    setLoadingDialogOpen,
    logId,
  } = useContext(ChillerLogsContext);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    if (!localUpdatedAt) {
      setRecentDataMessage('Edit some fields to save the data to your device.');
      return;
    }

    if (serverUpdatedAt < localUpdatedAt) {
      setRecentDataMessage('You have data saved to your device that is newer than the data saved to the server.');
    } else {
      setRecentDataMessage('The server is up to date.');
    }
  }, [serverUpdatedAt, localUpdatedAt]);

  const handleLoadFromDevice = () => {
    loadChillerLogsFromLocalStorage(logId);
    setLoadingDialogOpen(false);
  };

  const handleLoadFromServer = () => {
    fetchChillerLogs(logId);
    setLoadingDialogOpen(false);
  };

  return (
    <Dialog open={loadingDialogOpen} onClose={() => setLoadingDialogOpen(false)}>
      <Grid container spacing={2} style={{ minWidth: '400px', padding: '30px' }}>
        <Grid item xs={12}>
          {isOnline ? (
            <Typography variant="h5" style={{ color: 'green' }}>
              ONLINE
            </Typography>
          ) : (
            <Typography variant="h5" style={{ color: 'red' }}>
              OFFLINE
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }} className="no-print">
          {localUpdatedAt && <p style={{ fontSize: 13 }}>Last save to device: {localUpdatedAt}</p>}
          <p style={{ fontSize: 13 }}>Last save to server: {serverUpdatedAt}</p>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{recentDataMessage}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={handleLoadFromDevice} color="primary" disabled={!localUpdatedAt}>
            Load from Device
          </Button>
          {!localUpdatedAt && (
            <Typography variant="body2" style={{ fontSize: 12 }}>
              Cannot load from device. Nothing saved locally.
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={handleLoadFromServer} color="secondary" disabled={!isOnline}>
            Load from Server
          </Button>
          {!isOnline && (
            <Typography variant="body2" style={{ fontSize: 12 }}>
              Cannot load from server while offline.
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={() => history.goBack()}
            style={{ backgroundColor: '#f44336', color: 'white' }}
          >
            Back to Jobs
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default LoadingChoiceModal;
